import React, { useState, useEffect, Fragment } from 'react';
import MasterBar from '../../components/masterBar';
import TableCompare from '../../components/table';
import ElTabs from '../../components/elTabs';
import AtresBarChart from '../../components/charts/atresBarChart';
import Autocomplete from '../../components/autocomplete/index';
import BreadCrumb from '../../components/breadCrumb/';
import {
  TYPES,
  SUBTYPES,
  ELECTION_SPAIN_GENERAL_EUROPE
} from '../../envs/core';
import { ResultProvider } from '../../dataProvider/results';
import { getResultOrigin } from '../../dataProvider/origin';
import { getData } from '../../dataProvider/places/single';
import { PlacesProvider } from '../../dataProvider/places';
import './details.scss';

const getRoute = (town, electionNumber, year) => {
  const host = window.location.hostname.replace('localhost', 'ondacero');
  if (host.indexOf('lasexta') !== -1) {
    let currentYear = '';
    if (year !== '2019') {
      currentYear = '/' + year;
    }
    return `https://www.lasexta.com/noticias/nacional/elecciones-europeas/resultados${currentYear}/${electionNumber}${
      town ? town.path : '/comunidad-de-madrid/madrid'
    }`;
  }
  if (host.indexOf('antena3') !== -1) {
    return `https://www.antena3.com/noticias/elecciones/resultados/elecciones-europeas/${year}/${electionNumber}${
      town ? town.path : '/comunidad-de-madrid/madrid'
    }`;
  }
  if (host.indexOf('ondacero') !== -1) {
    let currentYear = '';
    if (year !== '2019') {
      currentYear = '/' + year;
    }
    return `https://www.ondacero.es/noticias/elecciones-europeas/resultados${currentYear}/${electionNumber}${
      town ? town.path : '/comunidad-de-madrid/madrid'
    }`;
  }
};

const EuropeDetail = ({ match, history }) => {
  const { year, electionNumber, town, reload, masterbar } = match.params;

  const type = TYPES.EUROPEAN;
  const elSubtype = SUBTYPES.SINGLE;
  const [autocomple, setAutocomple] = useState('');
  const [titleTown, setTitleTown] = useState('');
  const [resultOrigin, setResultOrigin] = useState({});

  useEffect(() => {
    getResultOrigin(year, type, electionNumber, ELECTION_SPAIN_GENERAL_EUROPE)
      .then(historicResult => {
        setResultOrigin(historicResult);
      })
      .catch(err => {});
  }, [year, electionNumber]);

  useEffect(() => {
    getData(town).then(place => {
      setTitleTown(place.name);
    });
  }, [town]);

  const goTo = child => {
    if (Boolean(parseInt(reload))) {
      window.location.href = getRoute(child, electionNumber, year);
    } else {
      if (child) {
        history.push(
          `/${masterbar}/${reload}/${year}/${electionNumber}/${
            child.ineId
          }/detalleEuropeas.html`
        );
      } else {
        history.push(
          `/${masterbar}/${reload}/${year}/${electionNumber}/resultadosEuropeas.html`
        );
      }
    }
  };

  return resultOrigin && resultOrigin.primary ? (
    <ResultProvider
      electionPlace={ELECTION_SPAIN_GENERAL_EUROPE}
      year={year}
      active={resultOrigin.primary.active}
      type={type}
      subtype={elSubtype}
      electionNumber={electionNumber}
      placeId={town === "null" ? null : town}
      details={true}
    >
      {dataResult => (
        <div className="pageDetails pageDetails_Europeas">
          <div className="mainWrapper">
            {Boolean(parseInt(masterbar)) && (
              <MasterBar
                current="europeas"
                history={history}
                reload={reload}
              />
            )}
            <div className="colContainer">
              {dataResult && dataResult.partiesResult ? (
                <div>
                  <div className="floatingBlock left">
                    <div className="inner">
                      <BreadCrumb type="EUROPEAS" onClick={goTo} />

                      <div className="mapContainer">
                        <div className="selectedTownContainer">
                          <span class="selectedTownTitle">
                            <span>{titleTown}</span>
                          </span>
                          <PlacesProvider
                            type="TOWN"
                            name={autocomple}
                            sortby={autocomple ? "score" : "name"}
                          >
                            {data => {
                              return (
                                <Autocomplete
                                  results={data}
                                  onChange={value => setAutocomple(value)}
                                  onSelect={select => {
                                    goTo(select);
                                  }}
                                  placeholder={"Seleccione municipio"}
                                  showArrow
                                />
                              );
                            }}
                          </PlacesProvider>
                        </div>

                        {dataResult &&
                        dataResult.partiesResult &&
                        town !== "null" ? (
                          <Fragment>
                            <table className="infoTable">
                              <tbody>
                                <tr>
                                  <td className="key">
                                    Votos contabilizados:{" "}
                                  </td>
                                  <td className="value votes">
                                    {Number(
                                      dataResult.totalVotes
                                    ).toLocaleString("es")}
                                  </td>
                                  <td className="value votes_percent">
                                    {Number(
                                      dataResult.currentCountPercent
                                    ).toLocaleString("es")}
                                    %
                                  </td>
                                </tr>
                                <tr>
                                  <td className="key">Abstenciones: </td>
                                  <td className="value votes">
                                    {Number(
                                      dataResult.abstentionVotes
                                    ).toLocaleString("es")}
                                  </td>
                                  <td className="value abstention_percent">
                                    {Number(
                                      dataResult.abstentionPercent
                                    ).toLocaleString("es")}
                                    %
                                  </td>
                                </tr>
                                <tr>
                                  <td className="key">Votos en blanco: </td>
                                  <td className="value whites">
                                    {Number(
                                      dataResult.whiteVotes
                                    ).toLocaleString("es")}
                                  </td>
                                  <td className="value whites_percent">
                                    {Number(
                                      dataResult.whitePercent
                                    ).toLocaleString("es")}
                                    %
                                  </td>
                                </tr>
                                <tr>
                                  <td className="key">Votos nulos: </td>
                                  <td className="value null">
                                    {Number(
                                      dataResult.invalidVotes
                                    ).toLocaleString("es")}
                                  </td>
                                  <td className="value null_percent">
                                    {Number(
                                      dataResult.invalidPercent
                                    ).toLocaleString("es")}
                                    %
                                  </td>
                                </tr>
                                {dataResult.totalSeats && (
                                  <tr>
                                    <td className="key">
                                      Total de escaños:{" "}
                                    </td>
                                    <td className="value votes">
                                      {Number(
                                        dataResult.totalSeats
                                      ).toLocaleString("es")}
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                            <AtresBarChart
                              data={dataResult.partiesResult || []}
                              dataKey="votesPercent"
                              showLabel={true}
                              seatTotal={dataResult.totalSeats || 0}
                            />
                          </Fragment>
                        ) : (
                          <div>Seleccione una localidad</div>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="floatingBlock right">
                    {dataResult && town !== "null" && (
                      <div className="inner">
                        <ElTabs titles={["Datos"]}>
                          <div>
                            {dataResult.partiesResult && (
                              <TableCompare
                                details
                                hideSeats={true}
                                data={dataResult.partiesResult}
                              />
                            )}
                          </div>
                          <div />{" "}
                          {/* Needed empty div due to weird tab behavior */}
                        </ElTabs>
                      </div>
                    )}
                  </div>
                </div>
              ) : (
                <div>No hay datos</div>
              )}
            </div>
          </div>
        </div>
      )}
    </ResultProvider>
  ) : (
    <div className="loader">Loading</div>
  );
};

export default EuropeDetail;
